import React, { useMemo } from "react";
import { Text, Tooltip } from "@chakra-ui/react";

/**
 * TruncatedText
 * - Single-line ellipsis truncation
 * - Optional character cap (hard limit) to prevent giant strings from affecting layout
 * - Tooltip shows full text
 */
const TruncatedText = ({
  value,
  maxChars = null, // e.g. 80 or 100
  tooltip = true,
  placement = "top-start",
  ...textProps
}) => {
  const fullText = (value ?? "").toString();

  const displayText = useMemo(() => {
    if (!maxChars || maxChars <= 0) return fullText;
    if (fullText.length <= maxChars) return fullText;
    return `${fullText.slice(0, maxChars).trimEnd()}…`;
  }, [fullText, maxChars]);

  const node = (
    <Text
      display="block"
      minW={0}
      w="100%"
      isTruncated
      {...textProps}
    >
      {displayText}
    </Text>
  );

  if (!tooltip || !fullText) return node;

  return (
    <Tooltip label={fullText} placement={placement} hasArrow openDelay={250}>
      {node}
    </Tooltip>
  );
};

export default TruncatedText;